import AndroidPayment from "./AndroidPayment";

export default AndroidPayment;



// WEBPACK FOOTER //
// ./src/apps/payment/containers/AndroidPayment/index.js